import React,{useEffect,useState,useContext} from "react";
import Moment from 'moment';
import { PrimaryButton } from '@fluentui/react'
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ACTIONS, AuthRoutes } from "../../constants/Constants";
import AddButton from "../../components/AddButton";
// import ColumnHeaders from './Columns';
import DataTable from "../../components/DataTable/DataTable";
import { useTranslation } from "react-i18next";
import { getHopitalsList,changeHospitalStatus } from "../../service/FirmServices";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools';
import ColumnsHospital from './ColumnHospital';
import PageHeader from "../../components/PageHeader";
import userContext from "../../context/users/UserContext";
import Toast from "../../components/Toast/Toast";
import ListView from "../../components/ListView/ListView";
const queryClient = new QueryClient()

const HospitalsList = () => {

    const [filterObj, setFilterObj] = useState({});
    const {showSuccessToast, setSuccessToast} = useContext(userContext);
    const [t, i18n] = useTranslation();
    const [loading,setLoading] = useState(false);
    const [searchClicked,setSearchClicked] = useState(false);
    const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
    const addIcon = {iconName: 'Add',style:{fontSize:13,lineHeight:1.5}};
    const clearIcon = {iconName: '12PointStar',style:{fontSize:13,lineHeight:1.5}};

     const checkCasing = (param)=>{
      if(param == "createdTimeString"){
        return "created_at";
      }else if(param == "updatedTimeString") {
        return "updated_at";
      }else if(param == "contact1.name" || param == "contact2.name" || param == "contact3.name"){
        return "contact_"+param.charAt(7);
      }
      else{
        return param;
      }
    }

    const fetchHospitalList = async (page, pageSize, pageFilter, pageSortBy) => {
        let sortyByDir = false;
        let sortParams = "created_at";
        if( pageSortBy != undefined && pageSortBy.length > 0 ) {
            sortParams = pageSortBy[0].id;
            sortyByDir = pageSortBy[0].desc
        }

        const body = {
          paginationDto:{
            pageNumber:page,
            pageSize:pageSize,
            sortField:checkCasing(sortParams),
            sortOrder:sortyByDir
          }
        }

        try{
          const response = await getHopitalsList(body);

          if (response.status === 200 && response.data.result === "SUCCESS") {
            // console.log(response.data.data.content);
             if(response.data.data.results.content != null || response.data.data.results.content != undefined){
              const data = {
               results: response.data.data.results.content,
               count: response.data.data.results.totalElements
               };
               return data;
             }else{
             }
           }
        }catch(e){
          console.log(e);
          setLoading(false);
        }
      };

    function updatePage(data){
      setUpdateCurrentPage(()=>!updateCurrentPage);
      setFilterObj({...filterObj,activeStatus:updateCurrentPage,row:data});
    }

    const handleClickGroup = async(event,data,cell)=>{
      console.log(event);
      console.log(data);
      console.log(cell);
      try{
         const response = await changeHospitalStatus(data);
         if (response.status === 200 && response.data.result === "SUCCESS") {
            updatePage(data);
         }
      }catch(e){
        console.log(e);
      }
  }


    const columns = ColumnsHospital(handleClickGroup);

    const buttonsTopBar = [{
      key : "1",
      button :  <Link
            key="1"
            to={AuthRoutes.MYADDHOSPITAL}
          >
            <div className="add-button-list-view">
              <AddButton text={t("hospital.add-hospital")} />
            </div>
  
          </Link>
    },
  ];

  const handleHospClick = async (cell) => {
    Navigate(AuthRoutes.MYADDHOSPITAL, {});
  };


    return (<div className="main-container-body">
      {showSuccessToast?
    <Toast  state="success"
        text={t("string-literals.hospital-added-success")}
       
      />
       : <></>
     }
      <ListView 
        pageHeader = "hospital.hospitals"
        buttonsTopBar = {buttonsTopBar}
        sortDropdownOptions = {[]}
        fetchDataFunction = {fetchHospitalList}
        columns = {columns}
        handleUserClick = {handleHospClick}
        widthContainer = "40%"
        updateCurrentPage = {updateCurrentPage}
        filterObj = {filterObj}
        heightTBody="67vh"
      />
      </div>);
}

export default HospitalsList;